import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import _get from 'lodash/get'
import _isEqual from 'lodash/isEqual'
import _isEmpty from 'lodash/isEmpty'
import _first from 'lodash/first'
import _find from 'lodash/find'
import cx from 'classnames'

import { Loader } from '@driftt/tide-core-legacy'
import { fetchSalesforceEnrichmentByEmail, fetchSFDCEnrichmentFields } from 'app/modules/sfdc/actions'
import Icon from 'svg-inline-react'
import SALESFORCE_ICON from '!svg-inline?removeTags=true!images/svg/sf-small.svg'
import * as SFDCSelectors from 'app/modules/sfdc/selectors'
import * as EnrichmentSelectors from 'app/modules/enrichment/selectors'

import * as style from './style'

class SalesforceSection extends Component {
  constructor(props) {
    super(props)

    this.state = { 
      loading: true,
      error: null,
      data: null,
      salesforceEnrichmentFields: [],
      requestedEnrichmentFields: false,
    }
  }

  componentDidMount() {
    this.enrichConversation()
  }
  
  componentDidUpdate(prevProps) {
    const { salesforceEnrichment, companyData, salesforceEnrichmentFields } = this.props
    const { requestedEnrichmentFields } = this.state
    if (!_isEqual(prevProps.salesforceEnrichment, salesforceEnrichment)) {
      this.setState({
        loading: _get(salesforceEnrichment, "loading") || false,
        error: _get(salesforceEnrichment, "error") || {},
        data: _get(salesforceEnrichment, "data") || {},
      })
    }

    if (!_isEqual(prevProps.companyData, companyData)) {
      this.enrichConversation()
    }

    if(!requestedEnrichmentFields && _isEmpty(salesforceEnrichmentFields)) {
      this.setState({ requestedEnrichmentFields: true },
        this.props.actions.fetchSFDCEnrichmentFields)
    }
  }

  enrichConversation = () => {
    const { email, companyData } = this.props
    const domain = _get(companyData, "domain")
    this.props.actions.fetchSalesforceEnrichmentByEmail({ email, domain })
  }

  renderSalesforceInfo = () => {
    const { data } = this.state
    const displayableData = this.getDisplayableData(data)

    const { salesforceEnrichmentFields } = this.props
    if(_isEmpty(salesforceEnrichmentFields) || salesforceEnrichmentFields.empty) {
      return this.renderDefaultSalesforceInfo(displayableData)
    } else {
      return this.renderCustomSalesforceInfo(salesforceEnrichmentFields, displayableData)
    }
  }

  getDisplayableData = (data) => {
    const account = _first(data.accounts) || {}
    const contact = _find(data.contacts, contact => !_isEmpty(account) || contact.AccountId === account.Id) || {}
    const lead = _find(data.leads, lead => !!lead.Email) || {}
    const opportunity = _find(data.opportunities, opp => !opp.IsClosed)
    const { baseUrl } = data
    return { account, contact, lead, opportunity, baseUrl }
  }

  renderDefaultSalesforceInfo = (data) =>
    <div>
      { !_isEmpty(data.opportunity) && this.renderSalesforceOpportunityBar() }
      { this.renderRow("Account Name", _get(data.account, "Name")) }
      { this.renderRow("Account Owner", _get(data.account, "ownerName")) }
      { this.renderRow("Contact Name", _get(data.contact, "Name")) }
      { this.renderRow("Contact Owner", _get(data.contact, "ownerName")) }
      { this.renderRow("Lead Stage", _get(data.lead, "Status")) }
      <a href={_get(data, "baseUrl") + _get(data.contact, "Id", _get(data.lead, "Id", _get(data.account, "Id")))} target="_blank">
        <div className="view-in-salesforce-bar">
          View in Salesforce
        </div>
      </a>
    </div>

  renderCustomSalesforceInfo = (salesforceEnrichmentFields, data) =>
    <div>
      { !_isEmpty(data.opportunity) && this.renderSalesforceOpportunityBar() }
      { salesforceEnrichmentFields.accountFields.map(field => this.renderRow(field.label, _get(data.account, field.name))) }
      { salesforceEnrichmentFields.contactFields.map(field => this.renderRow(field.label, _get(data.contact, field.name))) }
      { salesforceEnrichmentFields.leadFields.map(field => this.renderRow(field.label, _get(data.lead, field.name))) }
      <a href={_get(data, "baseUrl") + _get(data.contact, "Id", _get(data.lead, "Id", _get(data.account, "Id")))} target="_blank">
        <div className="view-in-salesforce-bar">
          View in Salesforce
        </div>
      </a>
    </div>

  renderRow = (header, value) =>
    <div key={header} className="sfdc-enrichment-body-row">
      <div className="sfdc-enrichment-row-header">
        { header }
      </div>
      <div className="sfdc-enrichment-row-body">
        { value ? value : "N/A" }
      </div>
    </div>

  renderSalesforceOpportunityBar = () =>
    <p className="opportunity-bar">
      💰 This account has an open opportunity
    </p>

  renderErrorState = () => {
    const { 
      error,
    } = this.state
    return <p>
      { error.status === 404 ? 
        "Couldn't find matching record in Salesforce" :
        "Error fetching data from Salesforce" }
    </p>
  }

  render() {
    const {
      className
    } = this.props
    const { 
      loading, 
      error } = this.state
    
    return(
      <div className={cx(style.conversationSection, className)}>
        <div className="section-header">
          <Icon src={ SALESFORCE_ICON } name="SALESFORCE_ICON" className="header-icon" />
          <span className="section-title">
            Salesforce Details
          </span>
        </div>
        <div className="section-body">
          { loading && <Loader /> }
          { !!_get(error, "status") && this.renderErrorState() }
          { (!loading && !_get(error, "status")) && this.renderSalesforceInfo() }
        </div>
      </div>
    )
  }
}

const makeMapStateToProps = () => {
  const getSalesforceEnrichmentByEmail = SFDCSelectors.makeGetSalesforceEnrichmentByEmail()
  
  return (state, props) => {
    const { email, ip } = props

    return {
      salesforceEnrichment: getSalesforceEnrichmentByEmail(state, email),
      companyData: EnrichmentSelectors.companyDataJS(state, { ip }),
      salesforceEnrichmentFields: SFDCSelectors.getSFDCEnrichmentFields(state),
    }
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    fetchSalesforceEnrichmentByEmail,
    fetchSFDCEnrichmentFields,
  }, dispatch)
})

export default connect(makeMapStateToProps, mapDispatchToProps)(SalesforceSection)


// WEBPACK FOOTER //
// ./src/scripts/components/conversation/ContactSideBar/Person/SalesforceSection/index.js